export enum EngineDeactivationReasonEnum {
  FacilityIssue = 1,
  ScheduledDowntime = 2,
  DynamicControlUnstable = 3,
  LogicAdjustments = 4,
  EcoplantReason = 5,
  OtherReason = 6,
}

export const EngineDeactivationReasonLabels: Record<EngineDeactivationReasonEnum, string> = {
  [EngineDeactivationReasonEnum.FacilityIssue]: 'Facility Issue (Power Outage, Connectivity Loss, etc.)',
  [EngineDeactivationReasonEnum.ScheduledDowntime]: 'Scheduled Plant Downtime / Change in System Demand',
  [EngineDeactivationReasonEnum.DynamicControlUnstable]:
    'Dynamic Control is Unstable (PSI Drops, Units not Reacting to Controls, etc.)',
  [EngineDeactivationReasonEnum.LogicAdjustments]: 'Logic Adjustments Requested / Compressor Health Concerns',
  [EngineDeactivationReasonEnum.EcoplantReason]: 'Ecoplant Reason',
  [EngineDeactivationReasonEnum.OtherReason]: 'Other Reason',
};
